export default "__VITE_PUBLIC_ASSET__aad0e5d5__"